import { css } from '@/styled-system/css';

export const conversationNavWrapperStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  borderBlock: '1px solid',
  borderColor: 'border.muted',
  paddingBlock: 'default',
  borderTop: 'none',
  lgDown: {
    backgroundColor: 'bg.screen.softest',
  },
  xl: {
    paddingInline: 'default',
  },
});

export const bulletSeparatedListStyles = css.raw({
  display: 'flex',
  alignItems: 'center',

  // Add bullet before each element except the first item and RentalTotalPriceLabel
  '& > *:not(:first-child):not([data-no-bullet])': {
    '&::before': {
      content: '"•"',
      marginInline: 'tightest',
      minWidth: 0,
    },
  },
});

export const totalPriceLabelWrapperStyles = css.raw({
  marginLeft: 'tighter',
  marginRight: 'tighter',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  '& .tmp-fees-may-apply': {
    paddingTop: '3px !important',
    marginBottom: 'tightest !important',
  },
});
